module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"displayName":"@:labels.displayName"},"fr":{"displayName":"@:labels.displayName"}}')
  delete Component.options._Ctor
}
